import React, { useRef } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { ThreeDots } from '../../common/Placeholders.jsx';
import { LoginRequired } from '../../../hoc/LoginRequired.jsx';
import { Page } from '../../../hoc/Page.jsx';
import { getCollectionAuthors } from '../../../actions/collection';
import CollectionAuthorCard from './CollectionAuthorCard.jsx';
import { ClientSidePaginationListEasy } from '../../../hoc/ClientSidePaginationListEasy.jsx';
import TitleFilter from '../../common/Filters/TitleFilter.jsx';
import { getVisibleCollectionAuthors } from '../../../reducers/collection-selector';


const CollectionAuthors = ({ count, isLoading, paginateList }) => {
  let history = useHistory();
  let ref = useRef(null);
  const handleClick = (slug) => {
    ref.current.scrollIntoView({ top: '-10px', behavior: 'smooth'});
    history.push(slug + `/`);
  }

  let items;
  if (count){
    items = paginateList.map(i => (
      <Col key={ i.id } xs={12} lg={6} className={'mb-3'}>
        <CollectionAuthorCard slug={ i.slug }
                              photo={ i.photo }
                              small_photo={ i.small_photo }
                              first_name={ i.first_name }
                              last_name={ i.last_name }
                              about={ i.about_html }
                              offer_count={ i.offer_count }
                              in_collection_count={ i.in_my_collection_offer_count }
                              rating_place={ i.rating_place }
                              url={ i.url }
                              onClick={ handleClick }/>
      </Col>))
  }

  if (isLoading) {
    return <ThreeDots/>
  }
  return(
    <div ref={ref}>
      <TitleFilter placeholder={ gettext('Введите Имя или Фамилию автора') }/>
      <Row>
        { items }
      </Row>
    </div>
  )
}

CollectionAuthors.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  count: PropTypes.number.isRequired,
  list: PropTypes.array.isRequired,
  paginateList: PropTypes.array.isRequired,

  getCollectionAuthors: PropTypes.func.isRequired,
}

let mapStateToProps = (state) => {
  return {
    list: getVisibleCollectionAuthors(state),
    pageSize: 20,
  }
};

export default compose(
  connect(mapStateToProps, { loadListFromServer: getCollectionAuthors }),
  LoginRequired,
  Page,
  ClientSidePaginationListEasy
)(CollectionAuthors);

